import React from "react";
import PropTypes from "prop-types";

const ModalConfirmacionCompra = ({ isOpen, compra, onClose, onConfirmar }) => {
    if (!isOpen || !compra) return null;

    const PRIMARY_COLOR = "rgb(53, 96, 90)";
    const SECONDARY_COLOR = "rgb(1, 165, 156)";

    const formatearMoneda = (valor, moneda = "PEN") => {
        const num = Number(valor || 0);
        return new Intl.NumberFormat("es-PE", {
            style: "currency",
            currency: moneda === "USD" ? "USD" : "PEN",
            minimumFractionDigits: 2,
        }).format(num);
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1040,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 5px 30px rgba(0, 0, 0, 0.3)",
                    maxWidth: "500px",
                    width: "95%",
                    padding: "0"
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    style={{
                        background: `linear-gradient(90deg, ${PRIMARY_COLOR} 0%, ${SECONDARY_COLOR} 100%)`,
                        color: "#fff",
                        padding: "20px",
                        borderRadius: "8px 8px 0 0",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <h5 style={{ margin: 0, fontSize: "1.1rem", fontWeight: 600 }}>
                        <i className="fas fa-file-invoice-dollar me-2"></i>
                        Registrar Compra de SUNAT
                    </h5>
                    <button
                        onClick={onClose}
                        style={{
                            background: "transparent",
                            border: "none",
                            color: "#fff",
                            fontSize: "1.5rem",
                            cursor: "pointer",
                            padding: 0
                        }}
                    >
                        ✕
                    </button>
                </div>

                <div style={{ padding: "20px" }}>
                    <p style={{ marginBottom: "15px", fontSize: "0.95rem" }}>
                        <strong>{compra.tipo_doc_descripcion || "Documento"}</strong> {compra.serie}-{compra.numero}
                    </p>
                    <p style={{ marginBottom: "5px", color: "#666", fontSize: "0.9rem" }}>
                        Proveedor: <strong>{compra.razon_social}</strong>
                    </p>
                    <p style={{ marginBottom: "15px", color: "#666", fontSize: "0.9rem" }}>
                        RUC: <strong>{compra.ruc_proveedor}</strong>
                    </p>
                    
                    <div style={{ backgroundColor: "#f5f5f5", padding: "10px", borderRadius: "4px", marginBottom: "15px" }}>
                        <p style={{ margin: "5px 0", fontSize: "0.9rem" }}>
                            Total: <strong>{formatearMoneda(compra.total, compra.moneda)}</strong>
                        </p>
                        <p style={{ margin: "5px 0", fontSize: "0.85rem", color: "#666" }}>
                            Fecha: {compra.fecha_emision ? new Date(compra.fecha_emision).toLocaleDateString("es-PE") : "—"}
                        </p>
                    </div>

                    <div style={{ backgroundColor: "#e8f5ff", border: `1px solid ${SECONDARY_COLOR}`, padding: "10px", borderRadius: "4px" }}>
                        <i className="fas fa-info-circle" style={{ color: SECONDARY_COLOR, marginRight: "8px" }}></i>
                        <small>Se abrirá el formulario de ingreso con estos datos pre-completados</small>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        padding: "15px 20px",
                        borderTop: "1px solid #ddd",
                        backgroundColor: "#f9f9f9"
                    }}
                >
                    <button
                        onClick={onClose}
                        style={{
                            padding: "8px 15px",
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "0.9rem"
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={() => onConfirmar(compra)}
                        style={{
                            padding: "8px 15px",
                            backgroundColor: SECONDARY_COLOR,
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "0.9rem",
                            fontWeight: 600
                        }}
                    >
                        <i className="fas fa-arrow-right me-2"></i>Continuar
                    </button>
                </div>
            </div>
        </div>
    );
};

ModalConfirmacionCompra.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    compra: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onConfirmar: PropTypes.func.isRequired
};

export default ModalConfirmacionCompra;
